import React from 'react';
import clsx from 'clsx';
import useStyles from './useStyles';

import { FormControlLabel, Grid, Radio, RadioGroup } from '@material-ui/core';

import { Controller, useFormContext } from 'react-hook-form';

import { CustomizedTypography } from '@components/Customized';

import { IRequestState } from '@modules/request';
import { CapaConsultingStartMethod } from '@generated/graphql';

import { useSelector } from '@store';

interface Props {
  handleUpdateRfqInfo: (payload: Partial<IRequestState>) => void;
}
export default function RequestForQuotationConsultMethod({
  handleUpdateRfqInfo
}: Props) {
  const classes = useStyles();

  const defaultConsultingStartMethod = useSelector(
    (state) => state.request.consultingStartMethod
  );
  const { control } = useFormContext();

  return (
    <section
      className={clsx(
        classes['rfq-consultationMethod-setting'],
        classes['rfq-info-section']
      )}
    >
      <div className="tooltip-title-box">
        <CustomizedTypography
          className="title"
          align="center"
          color="textPrimary"
        >
          상담 시작 방식을 선택해주세요.
        </CustomizedTypography>
      </div>

      <Controller
        name="consultingStartMethod"
        control={control}
        defaultValue={defaultConsultingStartMethod}
        render={(render) => {
          return (
            <RadioGroup
              {...render}
              onChange={(e) => {
                render.onChange(e.target.value);
                handleUpdateRfqInfo({
                  consultingStartMethod: e.target
                    .value as CapaConsultingStartMethod
                });
              }}
              className="radioGroup"
            >
              <FormControlLabel
                className={clsx('radioBox', {
                  'selected':
                    render.value === CapaConsultingStartMethod.QuotationRequired
                })}
                label={
                  <Grid container direction="column" className="radioInnerBox">
                    <Grid item className="radio-label-box">
                      <CustomizedTypography className="radio-label">
                        견적서를 제출한 경우에만
                        <br />
                        상담할래요
                      </CustomizedTypography>
                    </Grid>
                    <Grid item className="radio-label-list">
                      <CustomizedTypography
                        variant="body2"
                        color={
                          render.value ===
                          CapaConsultingStartMethod.QuotationRequired
                            ? 'textPrimary'
                            : 'textSecondary'
                        }
                        gutterBottoms={4}
                      >
                        여러 견적을 직접 비교해볼 수 있습니다.
                        <br />
                        상대적으로 상담 기회가 적을 수 있습니다.
                      </CustomizedTypography>
                    </Grid>
                  </Grid>
                }
                control={
                  <Radio
                    value={CapaConsultingStartMethod.QuotationRequired}
                    color="primary"
                    checked={
                      render.value ===
                      CapaConsultingStartMethod.QuotationRequired
                    }
                  />
                }
              />
              <FormControlLabel
                className={clsx('radioBox', {
                  'selected':
                    render.value ===
                    CapaConsultingStartMethod.PartnerIntroductionAvailable
                })}
                label={
                  <Grid container direction="column" className="radioInnerBox">
                    <Grid item className="radio-label-box">
                      <CustomizedTypography className="radio-label">
                        견적서가 없으면
                        <br />
                        회사소개서만이라도 받아볼래요
                      </CustomizedTypography>
                    </Grid>

                    <Grid item className="radio-label-list">
                      <CustomizedTypography
                        variant="body2"
                        color={
                          render.value ===
                          CapaConsultingStartMethod.PartnerIntroductionAvailable
                            ? 'textPrimary'
                            : 'textSecondary'
                        }
                        gutterBottoms={4}
                      >
                        더 많은 파트너와 상담할 수 있습니다.
                        <br />
                        견적이 없을 경우엔 '회사소개서'를 제공합니다.
                      </CustomizedTypography>
                    </Grid>
                  </Grid>
                }
                control={
                  <Radio
                    value={
                      CapaConsultingStartMethod.PartnerIntroductionAvailable
                    }
                    color="primary"
                    checked={
                      render.value ===
                      CapaConsultingStartMethod.PartnerIntroductionAvailable
                    }
                  />
                }
              />
            </RadioGroup>
          );
        }}
      />
    </section>
  );
}
